var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./commend.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;


//////////////////
// WEBPACK FOOTER
// ./node_modules/style-loader/dist/cjs.js!./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/assets/style/less/commend.less
// module id = idm1
// module chunks = 6